import { render } from "./BaseSpinner.vue?vue&type=template&id=0717fccc&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=0717fccc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\MK\\Desktop\\paymentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0717fccc"]])

export default __exports__